import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Input, Divider, Image, Tooltip, Button, Card, Statistic, Alert } from "antd";
import Message from "../../Components/common/Message";
import { useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import AuthService from "../../Components/auth/AuthService";
import { useDispatch, useSelector } from "react-redux";
import { Button as UploadButton } from "@mui/material";
import config from "../../Components/config";
import qs from "query-string";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { ArrowLeftOutlined, CloseOutlined } from "@ant-design/icons";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import "./cashup.css";
import SignatureCanvas from "react-signature-canvas";

const Auth = new AuthService();
const useStyles = makeStyles((theme) => ({
  antInput: {
    "& .ant-input": {
      height: "40px",
    },
    "& .ant-input-outlined[disabled]": {
      color: "black"
    }
  },
  dataSheet: {
    "& .ant-checkbox .ant-checkbox-inner": {
      width: "36px",
      height: "36px"
    },
    "& .ant-checkbox+span": {
      fontSize: '16px',
      paddingTop: '6px'
    },
    "& .ant-checkbox-checked .ant-checkbox-inner:after": {
      width: '10px',
      height: '22px'
    },

    "& .ant-card .ant-card-body": {
      padding: "4px",
      // backgroundColor: 'rgb(240, 240, 240)',
    },
    "& .ant-statistic .ant-statistic-content": {
      fontSize: "12px",
      fontWeight: "bold",
    },
    "& .ant-statistic .ant-statistic-title": {
      fontSize: "12px",
    },
  }
}));

const Cashup = () => {
  const { pinValidity } = useSelector((state) => state?.AppState?.driverData);
  const { selectedRoute } = useSelector((state) => state?.AppState?.driverData);
  const navigate = useNavigate();
  const { TextArea } = Input;
  const classes = useStyles();
  const dispatch = useDispatch();
  const securityPinExists = localStorage.getItem("securityPin");
  var layoutDispatch = useLoadingDispatch();

  const location = useLocation();
  const selectedAmount = location?.state?.totalAmounts;

  const infoItems = [
    { label: "Overdue Vehicles", count: 15, color: "red" },
    { label: "Due Soon Vehicles", count: 2, color: "orange" },
    { label: "Snoozed Vehicles", count: 0, color: "grey" },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [notes, setNotes] = useState("");
  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);

  const [fiftyPoundBillCount, setFiftyPoundBillCount] = useState("");
  const [twentyPoundBillCount, setTwentyPoundBillCount] = useState("");
  const [tenPoundBillCount, setTenPoundBillCount] = useState("");
  const [fivePoundBillCount, setFivePoundBillCount] = useState("");
  const [totalCoinAmount, setTotalCoinAmount] = useState(0);
  const [totalNotesAmount, setTotalNotesAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const signatureCanvasRef = useRef(null);
  const [signature, setSignature] = useState("");

  const clearSignature = () => {
    signatureCanvasRef.current.clear();
    setSignature('')

  };

  const saveSignature = () => {
    const signatureImage = signatureCanvasRef.current.toDataURL();
    setSignature(signatureImage);
  };


  const [coinCount, setCoinCount] = useState({
    oneP: '',
    twoP: '',
    fiveP: '',
    tenP: '',
    TwentyP: '',
    fiftyP: '',
    onePound: '',
    twoPound: ''
  });

  if (!pinValidity) {
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.setItem('routeLocation', false)
    navigate("/pin");
    dispatch({ type: "RESET_STATE" });
  }

  if (!securityPinExists) {
    navigate("/pin");
    localStorage.removeItem("DriverName");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${file.name.split(".")[1]
        }`;
      setLoadMessage("");
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const getUploadUrl = async (file) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/cashup/" + selectedRoute + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const handleSaveCashUp = async () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    if (!signature) {
      setType('error')
      setLoadMessage('Sign Before Submitting')
      return;
    }
    if(currentItemFiles?.length < 1) {
      setType('error')
      setLoadMessage('Please add at least one file to proceed.' + str)
      return
    }
    const cashUpData = {
      dc_fifty_notes: fiftyPoundBillCount,
      dc_twenty_notes: twentyPoundBillCount,
      dc_ten_notes: tenPoundBillCount,
      dc_five_notes: fivePoundBillCount,
      //   dc_change_total: totalCoinAmount,
      dc_notes: notes,
      dc_files: currentItemFiles,
      route_status_id: selectedRoute,
      dc_fifty_pennies_coins: coinCount.fiftyP,
      dc_twenty_pennies_coins: coinCount.TwentyP,
      dc_ten_pennies_coins: coinCount.tenP,
      dc_five_pennies_coins: coinCount.fiveP,
      dc_two_pennies_coins: coinCount.twoP,
      dc_one_pennies_coins: coinCount.oneP,
      dc_one_pound_coins: coinCount.onePound,
      dc_two_pound_coins: coinCount.twoPound,
      cashup_signature: signature
    };
    setIsLoading(true)
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch("/driverapp/update-driver-cashup", {
        method: "POST",
        body: JSON.stringify(cashUpData),
      });
      if (res.ack) {
        const uploadPromises = files?.map(async (f, idx) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            console.error("Error uploading file:", error);
          }
        });

        Promise.all(uploadPromises);
        setLoadMessage(res.message)
        setType('success')
        navigate('/routes')
      } else {
        setLoadMessage(res.message)
        setType('error')
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
      hideLoading(layoutDispatch);
    }

  };

  useEffect(() => {
    const fetchData = async () => {
      if (selectedRoute) {
        showLoading(layoutDispatch);
        try {
          const res = await Auth.fetch(`/driverapp/get-driver-cashup?route_status_id=${selectedRoute}`);
          if (res?.ack) {
            setFiftyPoundBillCount(res?.driver_cashup?.dc_fifty_notes || "")
            setTwentyPoundBillCount(res?.driver_cashup?.dc_twenty_notes || "")
            setTenPoundBillCount(res?.driver_cashup?.dc_ten_notes || "")
            setFivePoundBillCount(res?.driver_cashup?.dc_five_notes || "")
            //   setTotalCoinAmount(res?.driver_cashup?.dc_change_total || "")
            setNotes(res?.driver_cashup?.dc_notes || "")
            setSignature(res?.driver_cashup?.cashup_signature || "")
            setCurrentItemFiles(res?.driver_cashup?.dc_files ? JSON.parse(res?.driver_cashup?.dc_files) : [])
            setCoinCount((prevCoins) => ({
              ...prevCoins,
              oneP: res?.driver_cashup?.dc_one_pennies_coins,
              twoP: res?.driver_cashup?.dc_two_pennies_coins,
              fiveP: res?.driver_cashup?.dc_five_pennies_coins,
              tenP: res?.driver_cashup?.dc_ten_pennies_coins,
              TwentyP: res?.driver_cashup?.dc_twenty_pennies_coins,
              fiftyP: res?.driver_cashup?.dc_fifty_pennies_coins,
              onePound: res?.driver_cashup?.dc_one_pound_coins,
              twoPound: res?.driver_cashup?.dc_two_pound_coins,


            }));
          }
        } catch (err) {
          console.log(err)
        } finally {
          hideLoading(layoutDispatch);
        }
      }

    }
    fetchData()
  }, [])

  const calculateTotalCoinAmount = () => {
    const totalCoin =
      (coinCount.oneP ? parseInt(coinCount.oneP) : 0) * 0.01 +
      (coinCount.twoP ? parseInt(coinCount.twoP) : 0) * 0.02 +
      (coinCount.fiveP ? parseInt(coinCount.fiveP) : 0) * 0.05 +
      (coinCount.tenP ? parseInt(coinCount.tenP) : 0) * 0.10 +
      (coinCount.TwentyP ? parseInt(coinCount.TwentyP) : 0) * 0.20 +
      (coinCount.fiftyP ? parseInt(coinCount.fiftyP) : 0) * 0.50 +
      (coinCount.onePound ? parseInt(coinCount.onePound) : 0) * 1.00 +
      (coinCount.twoPound ? parseInt(coinCount.twoPound) : 0) * 2.00;

    setTotalCoinAmount(totalCoin.toFixed(2));

  }

  useEffect(() => {
    calculateTotalCoinAmount();
  }, [coinCount]);

  const calculateTotalNoteAmount = () => {
    const totalNote =
      (fiftyPoundBillCount ? parseInt(fiftyPoundBillCount) : 0) * 50.00 +
      (twentyPoundBillCount ? parseInt(twentyPoundBillCount) : 0) * 20.00 +
      (tenPoundBillCount ? parseInt(tenPoundBillCount) : 0) * 10.00 +
      (fivePoundBillCount ? parseInt(fivePoundBillCount) : 0) * 5.00;

    setTotalNotesAmount(totalNote.toFixed(2));
  }

  useEffect(() => {
    calculateTotalNoteAmount();
  }, [fiftyPoundBillCount, twentyPoundBillCount, tenPoundBillCount, fivePoundBillCount]);

  const calculateTotalAmount = () => {
    const total =
      (totalCoinAmount ? parseFloat(totalCoinAmount) : 0) + (totalNotesAmount ? parseFloat(totalNotesAmount) : 0)


    setTotalAmount(total);
  }

  useEffect(() => {
    calculateTotalAmount();
  }, [totalCoinAmount, totalNotesAmount]);

  console.log('currentItemFiles', currentItemFiles)

  return (
    <div className={classes.dataSheet}>
      <Row style={{ display: "flex", justifyContent: 'start' }}>
        <Button size="large" icon={<ArrowLeftOutlined />} onClick={() => navigate("/routes")}>Back</Button>
      </Row>
      <br/>
      <div className="info-box">
        <div className="single-info-box">
          <div style={{ display: "flex" }}>
            <div className="box-content">
              <span style={{ borderBottom: "1px dotted", fontSize: "13px" }}>
                Cash Total
              </span>
              <span style={{ fontSize: "13px" }}>
                <span
                  style={{
                    color: "green",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  £{selectedAmount?.cashAmount ? selectedAmount?.cashAmount : 0}
                </span>{" "}
                {/* on-time */}
              </span>
            </div>
          </div>
        </div>
        <div className="single-info-box">
          <div style={{ display: "flex" }}>
            <div className="box-content">
              <span style={{ borderBottom: "1px dotted", fontSize: "13px" }}>
                Card Total
              </span>
              <span style={{ fontSize: "13px" }}>
                <span
                  style={{
                    color: "green",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  £{selectedAmount?.cardAmount ? selectedAmount?.cardAmount : 0}
                </span>{" "}
                {/* on-time */}
              </span>
            </div>
          </div>
        </div>
        {/* <div className="single-info-box">
          <div style={{ display: "flex" }}>
            <div className="box-content">
              <span style={{ borderBottom: "1px dotted", fontSize: "13px" }}>
                Bank Total
              </span>
              <span style={{ fontSize: "13px" }}>
                <span
                  style={{
                    color: "green",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  £{selectedAmount?.accountAmount ? selectedAmount?.accountAmount : 0}
                </span>{" "}
              </span>
            </div>
          </div>
        </div> */}
      </div>


      <div style={{ display: "flex", justifyContent: "space-between" }}>

        <h2 >Cash Up</h2>
        <div>
          <Row gutter={[10, 16]}>
            <Card style={{ backgroundColor: "#f0f0f0", width: '150px', marginRight: '10px' }}>
              <Statistic
                title="Total Notes Amount"
                value={"£" + totalNotesAmount}
                precision={2}
                valueStyle={{
                  color: "#3f8600",
                }}
              // prefix="£"
              />
            </Card>
            <Card style={{ backgroundColor: "#f0f0f0", width: '150px', marginRight: '10px' }}>
              <Statistic
                title="Total Coin Amount"
                value={"£" + totalCoinAmount}
                precision={2}
                valueStyle={{
                  color: "#3f8600",
                }}
              // prefix="£"
              />
            </Card>

            <Card style={{ backgroundColor: "#f0f0f0", width: '150px' }}>
              <Statistic
                style={{ "&.ant-statistic .ant-statistic-title": { fontSize: '16px !important' } }}
                title="Total Amount"
                value={"£" + totalAmount.toFixed(2)}
                precision={2}
                valueStyle={{
                  color: "#3f8600",
                }}
              // prefix="£"
              />
            </Card>

          </Row>
        </div>

      </div>



      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            £50 Notes
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter £50 Count"
              type="number"
              onChange={(e) => setFiftyPoundBillCount(e.target.value)}
              value={fiftyPoundBillCount}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total £50 Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="£50 Amount"
              disabled
              // type="number"
              // value={(fiftyPoundBillCount ? parseInt(fiftyPoundBillCount) * 50 : 0).toFixed(2)}
              value={"£" + (fiftyPoundBillCount ? parseInt(fiftyPoundBillCount) * 50.00 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            £20 Notes
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter £20 Count"
              type="number"
              onChange={(e) => setTwentyPoundBillCount(e.target.value)}
              value={twentyPoundBillCount}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total £20 Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="£20 Amount"
              disabled
              // type="text"
              value={"£" + (twentyPoundBillCount ? parseInt(twentyPoundBillCount) * 20.00 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            £10 Notes
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter £10 Count"
              type="number"
              onChange={(e) => setTenPoundBillCount(e.target.value)}
              value={tenPoundBillCount}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total £10 Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="£10 Amount"
              disabled
              // type="number"
              value={"£" + (tenPoundBillCount ? parseInt(tenPoundBillCount) * 10.00 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            £5 Notes
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter £5 Count"
              type="number"
              onChange={(e) => setFivePoundBillCount(e.target.value)}
              value={fivePoundBillCount}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total £5 Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="£5 Amount"
              disabled
              // type="number"
              value={"£" + (fivePoundBillCount ? parseInt(fivePoundBillCount) * 5.00 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            £2 Coins
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter £2 Count"
              type="number"
              value={coinCount.twoPound}
              onChange={(e) => {
                setCoinCount((prevCoins) => ({
                  ...prevCoins,
                  twoPound: e.target.value
                }));
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total £2 Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="£2 Amount"
              // type="number"
              disabled
              value={"£" + (coinCount.twoPound ? parseInt(coinCount.twoPound) * 2.00 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            £1 Coins
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter £1 Count"
              type="number"
              value={coinCount.onePound}
              onChange={(e) => {
                setCoinCount((prevCoins) => ({
                  ...prevCoins,
                  onePound: e.target.value
                }));
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total £1 Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="£1 Amount"
              // type="number"
              disabled
              value={"£" + (coinCount.onePound ? parseInt(coinCount.onePound) * 1.00 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            50p Coins
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter 50p Count"
              type="number"
              value={coinCount.fiftyP}
              onChange={(e) => {
                setCoinCount((prevCoins) => ({
                  ...prevCoins,
                  fiftyP: e.target.value
                }));
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total 50p Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="50p Amount"
              // type="number"
              disabled
              value={"£" + (coinCount.fiftyP ? parseInt(coinCount.fiftyP) * 0.50 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            20p Coins
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter 20p Count"
              type="number"
              value={coinCount.TwentyP}
              onChange={(e) => {
                setCoinCount((prevCoins) => ({
                  ...prevCoins,
                  TwentyP: e.target.value
                }));
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total 20p Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="20p Amount"
              // type="number"
              disabled
              value={"£" + (coinCount.TwentyP ? parseInt(coinCount.TwentyP) * 0.20 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            10p Coins
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter 10p Count"
              type="number"
              value={coinCount.tenP}
              onChange={(e) => {
                setCoinCount((prevCoins) => ({
                  ...prevCoins,
                  tenP: e.target.value
                }));
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total 10p Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="10p Amount"
              // type="number"
              disabled
              value={"£" + (coinCount.tenP ? parseInt(coinCount.tenP) * 0.10 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            5p Coins
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter 5p Count"
              type="number"
              value={coinCount.fiveP}
              onChange={(e) => {
                setCoinCount((prevCoins) => ({
                  ...prevCoins,
                  fiveP: e.target.value
                }));
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total 5p Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="5p Amount"
              // type="number"
              disabled
              value={"£" + (coinCount.fiveP ? parseInt(coinCount.fiveP) * 0.05 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            2p Coins
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter 2p Count"
              type="number"
              value={coinCount.twoP}
              onChange={(e) => {
                setCoinCount((prevCoins) => ({
                  ...prevCoins,
                  twoP: e.target.value
                }));
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total 2p Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="2p Amount"
              // type="number"
              disabled
              value={"£" + (coinCount.twoP ? parseInt(coinCount.twoP) * 0.02 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>





      <Row gutter={[6, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            1p Coins
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter 1p Count"
              type="number"
              value={coinCount.oneP}
              onChange={(e) => {
                setCoinCount((prevCoins) => ({
                  ...prevCoins,
                  oneP: e.target.value
                }));
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Total 1p Amount
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="1p Amount"
              // type="number"
              disabled
              value={"£" + (coinCount.oneP ? parseInt(coinCount.oneP) * 0.01 : 0).toFixed(2)}
            />
          </div>
        </Col>
      </Row>








      <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>Notes</h4>
      <div style={{ marginBottom: "10px" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <TextArea
              autoSize={{ minRows: 6, maxRows: 12 }}
              label="Notes"
              placeholder="Enter Any Specific Notes"
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
            />
          </Col>
        </Row>
      </div>
      <Divider />
      
      <div
        style={{
          width: 450,
          display: "flex",
          alignItems: 'end',
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
        Signature<span style={{ color: "red", fontSize: "15px" }}>*</span>
      </h4>
        <Button
          size="large"
          danger
          onClick={clearSignature}
        >
          Clear Signature
        </Button>
      </div>
      <div className="sign-con">
        <SignatureCanvas
          ref={signatureCanvasRef}
          value={signature}
          penColor="purple"
          canvasProps={{
            width: 450,
            height: 200,
            className: "signature-canvas",
          }}
          onEnd={saveSignature}
        />
        <div>
          {signature && <img height={150} width={250} src={signature} />}
        </div>
      </div>
      
      <Divider />
      <div style={{ display: 'flex'}}>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            accept="image/*, video/*"
            onChange={(e) => {
              handleSubmitImage(e);
            }}
          />
        </UploadButton>
        <Alert style={{ width: '180px', marginTop: "10px", marginLeft: "5px"}} message={'Images are required'} type="info" showIcon/>
      </div>
      {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
      <Image.PreviewGroup>
        {currentItemFiles?.length > 0 &&
          currentItemFiles
            .filter((item) => !files.some((file) => file.name === item))
            .map((item) => {
              const imageUrl = `${config.tms_uploads_cdn}/${config.env}/cashup/${selectedRoute}/${item}`;
              return (
                <div
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    display: "inline-block",
                  }}
                >
                  <Image
                    width={200}
                    height={150}
                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                    src={imageUrl}
                  />
                  <Tooltip title="Delete">
                    <CloseOutlined
                      style={{
                        fontSize: "30px",
                        position: "absolute",
                        right: 5,
                        top: 5,
                        color: "#c12828",
                      }}
                      onClick={() => handleDeleteCurrentFile(item)}
                    />
                  </Tooltip>
                </div>
              );
            })}
      </Image.PreviewGroup>
      <Divider />
      {files?.length > 0 && <h4>New Files:</h4>}
      <Image.PreviewGroup>
        {files?.length > 0 &&
          files?.map((files) => {
            return (
              <div
                style={{
                  position: "relative",
                  marginRight: "10px",
                  display: "inline-block",
                }}
              >
                <Image
                  width={200}
                  height={150}
                  style={{ padding: "5px", border: "1px solid lightgrey" }}
                  src={URL.createObjectURL(files.file)}
                />
                <Tooltip title="Delete">
                  <CloseOutlined
                    style={{
                      fontSize: "30px",
                      position: "absolute",
                      right: 5,
                      top: 5,
                      color: "#c12828",
                    }}
                    onClick={() => handleDeleteFile(files.name)}
                  />
                </Tooltip>
              </div>
            );
          })}
      </Image.PreviewGroup>
      {files?.length > 0 && <Divider />}

      <div
        style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
      >
        <Button
          onClick={() => navigate("/routes")}
          danger
          size="large"
          style={{ marginRight: "10px" }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          loading={isLoading}
          size="large"
          onClick={handleSaveCashUp}
        >
          Save
        </Button>
      </div>

      <Message type={type} msg={loadMessage} />
    </div>
  );
};

export default Cashup;
